import {FlightRequest} from 'acscp/components/flightRequest/flightRequest';
import React from 'react';
import {PresentationComponentBase} from 'acscp/components/presentationComponentBase';
import {QuotesList} from 'acscp/components/quotes/quotesList';
import {AppState, Booking, Quote} from 'acscp/store';
import {Dispatch} from 'redux';
import {QuotesRequest, RequestClass} from 'acscp/api/requests';
import {FetchRequest} from 'acscp/actions';
import {getBookingQuotes} from 'acscp/store/helpers/getBookingQuotes';
import {FormattedMessage} from 'react-intl';
import {connectWithRequests} from 'acscp/store/helpers/connectWithRequests';
import {RequestStateProps} from 'acscp/components/common/helpers/requestStateProps';
import {QuoteType} from 'acscp/api/models/customTypes/quoteType';
import { Row } from 'acscp/components/common/row';
import style from './quotes.module.scss';
import acmiLogo from 'acscp/assets/acmiLogo.png';
import acaLogo from 'acscp/assets/member_air_charter_accociation@2x.png';
import airlineEconomicsLogo from 'acscp/assets/member_airline_economics@2x.png';
import istatLogo from 'acscp/assets/member_istat@2x.png';
import aviationClubLogo from 'acscp/assets/member_aviation_club_uk@2x.png';
import classNames from 'classnames';

interface QuotesOwnProps {
    bookingDetails: Booking;
}

interface QuotesStateProps {
    quotes: Quote[];
    fetchIsRunning: boolean;
}

interface QuotesDispatchProps {
    fetchQuotes: () => void;
}

export class QuotesPresentational
    extends PresentationComponentBase<QuotesOwnProps, QuotesStateProps, QuotesDispatchProps, {}> {

    componentDidMount(): void {
        this.props.fetchQuotes();
    }

    render(): JSX.Element {
        const { bookingDetails, fetchIsRunning, quotes } = this.props;
        const jetCardHolder = bookingDetails.jetCardNo !== '';
        const bookingHasQuotes = quotes.length > 1
            || (fetchIsRunning && bookingDetails.status === 'QuotesAvailable'); // preempt quotes being returned
        const shouldShowFlightPlan = fetchIsRunning
            || quotes.length === 0
            || quotes[0].quoteType === QuoteType.Standard
            || quotes[0].quoteType === QuoteType.ACMI;
        const isInAcmiWorkflow = bookingDetails.isInAcmiWorkflow;
        const bookingTitle = isInAcmiWorkflow ? (
                <FormattedMessage
                    id={'components.flightRequest.acmiTitle'}
                    defaultMessage={'ACMI REQUEST'}
                />
            ) :
            bookingHasQuotes ? (
                <FormattedMessage
                    id={'components.quotes.title'}
                    defaultMessage={'QUOTES'}
                />
            ) : (
                <FormattedMessage
                    id={'components.flightRequest.charterRequest'}
                    defaultMessage={'CHARTER REQUEST'}
                />
            );
        return (
            <div>
                <FlightRequest
                    bookingDetails={bookingDetails}
                    quoteCount={fetchIsRunning ? null : quotes.length}
                    shouldShowFlightPlan={shouldShowFlightPlan}
                    title={bookingTitle}
                />
                <QuotesList
                    quotes={quotes}
                    jetCardHolder={jetCardHolder}
                    jetCardType={bookingDetails.jetCardType}
                    isInAcmiWorkflow={bookingDetails.isInAcmiWorkflow}
                />
                {isInAcmiWorkflow &&
                    <Row className={style.AcmiLogoRow}>
                        <div className={style.AcmiLogoContainer}>
                            <img src={acmiLogo} alt={'ACMI Logo'} className={style.AcmiLogos}/>
                        </div>
                        <div className={style.AcmiLogoContainer}>
                            <img src={aviationClubLogo} alt={'Aviation Club Logo'} className={style.AcmiLogos}/>
                            <img src={istatLogo} alt={'ISTAT Logo'} className={style.AcmiLogos}/>
                            <img src={acaLogo} alt={'Air Charter Association Logo'} className={style.AcmiLogos}/>
                            <img
                                src={airlineEconomicsLogo}
                                alt={'Airline Economics Logo'}
                                className={classNames(style.AcmiLogos, style.AirlineEconomicsLogo)}
                            />
                        </div>
                    </Row>
                }
            </div>
        );
    }
}

function mapStateToProps(
    state: AppState,
    ownProps: QuotesOwnProps,
    getRequestError: (request: RequestClass<any>) => RequestStateProps
): QuotesStateProps {
    return {
        quotes: getBookingQuotes(state.quotes, ownProps.bookingDetails.id),
        fetchIsRunning: getRequestError(QuotesRequest).isLoading,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: QuotesOwnProps): QuotesDispatchProps {
    return {
        fetchQuotes: () => dispatch(new FetchRequest(new QuotesRequest(ownProps.bookingDetails.id)))
    };
}

export const Quotes = connectWithRequests(mapStateToProps, mapDispatchToProps)(QuotesPresentational);
